import React, { useState, useReducer } from 'react';
import CryptoJS from "crypto-js";


if (sessionStorage.getItem("Garden")) {
	const storedData = sessionStorage.getItem("Garden");
	var bytes = CryptoJS.AES.decrypt(storedData, 'RangaFulan09');
	var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
	// console.log(decryptedData);
}


if (sessionStorage.getItem("GardenuserName")) {
	const storedData = sessionStorage.getItem("GardenuserName");
	var bytes = CryptoJS.AES.decrypt(storedData, 'RangaFulan09userName');
	var decryptedDatausername = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
	console.log('decryptedDatausername', decryptedDatausername);
}

if (sessionStorage.getItem("Gardenpassword")) {
	const storedData = sessionStorage.getItem("Gardenpassword");
	var bytes = CryptoJS.AES.decrypt(storedData, 'RangaFulan09password');
	var decryptedDatapassword = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
	console.log('decryptedDatapassword', decryptedDatapassword);
}

let token = decryptedData ? decryptedData.access_token : '';
let UserFullName = decryptedData ? decryptedData.UserFullName : '';
let RoleID = decryptedData ? decryptedData.RoleID : '';
let UserID = decryptedData ? decryptedData.UserID : '';
let DepartmentID = decryptedData ? decryptedData.DepartmentID : '';
let DesignationID = decryptedData ? decryptedData.DesignationID : '';
let EmployeeID = decryptedData ? decryptedData.EmployeeID : '';
let ClientID = decryptedData ? decryptedData.ClientID : '';
let M_ProjectTypeID = decryptedData ? decryptedData.M_ProjectTypeID : '';
let LoginUsername = decryptedDatausername ? decryptedDatausername : '';
let LoginPassword = decryptedDatausername ? decryptedDatapassword : '';
let MobileNumber = decryptedData ? decryptedData.MobileNumber : '';

export const initialState = {
	username: '' || UserFullName,
	RoleID: '' || RoleID,
	UserID: '' || UserID,
	token: '' || token,
	DepartmentID: '' || DepartmentID,
	DesignationID: '' || DesignationID,
	EmployeeID: '' || EmployeeID,
	ClientID: '' || ClientID,
	M_ProjectTypeID: '' || M_ProjectTypeID,
	LoginUsername: LoginUsername,
	LoginPassword: LoginPassword,
	MobileNumber : '' || MobileNumber,
	loading: false,
	errorMessage: null,
};

export const AuthReducer = (initialState, action) => {
	// console.log(action.payload)
	switch (action.type) {
		case 'REQUEST_LOGIN':
			return {
				...initialState,
				loading: true,
			};
		case 'LOGIN_SUCCESS':
			return {
				...initialState,
				username: action.payload.UserFullName,
				RoleID: action.payload.RoleID,
				UserID: action.payload.UserID,
				token: action.payload.access_token,
				DepartmentID: action.payload.DepartmentID,
				DesignationID: action.payload.DesignationID,
				EmployeeID: action.payload.EmployeeID,
				ClientID: action.payload.ClientID,
				MobileNumber : action.payload.MobileNumber,
				M_ProjectTypeID: action.payload.M_ProjectTypeID,
				LoginUsername: LoginUsername,
				LoginPassword: LoginPassword,
				loading: false,
			};
		case 'LOGOUT':
			return {
				...initialState,
				username: '',
				RoleID: '',
				UserID: '',
				DepartmentID: '',
				DesignationID: '',
				EmployeeID: '',
				MobileNumber:'',
				ClientID: '',
				M_ProjectTypeID: '',
				token: '',
				LoginUsername: '',
				LoginPassword: '',
			};

		case 'LOGIN_ERROR':
			return {
				...initialState,
				loading: false,
				errorMessage: action.error,
			};

		default:
			throw new Error(`Unhandled action type: ${action.type}`);
	}
};
